import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';

import TextField from 'components/fields/TextField';

import * as validate from 'utils/validate';
import * as normalize from 'utils/normalize';

const styles = theme => ({
  root: {
    display: 'flex',
  },
  fields: {
    display: 'flex',
  },
  textField: {
    maxWidth: '25%',
    flexBasis: '25%',
    '& input': {
      paddingLeft: 2,
      paddingRight: 2,
      textAlign: 'center',
    },
  },
  textFieldNotFirst: {
    position: 'relative',
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: -2,
      width: 3,
      backgroundColor: theme.palette.grey[100],
      borderTop: `1px solid ${theme.palette.grey[600]}`,
      borderBottom: `1px solid ${theme.palette.grey[600]}`,
      zIndex: 1,
    },
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 7,
      bottom: 7,
      left: -1,
      width: 1,
      backgroundColor: theme.palette.grey[600],
      zIndex: 2,
    },
  },
  inputRootNotFirst: {
    borderLeft: 'none',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  inputRootNotLast: {
    borderRight: 'none',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  labelOverlap: {
    position: 'relative',
    marginBottom: -6,
    marginLeft: 4,
    width: 'fit-content',
    zIndex: 2,
    '&:after': {
      content: '""',
      display: 'block',
      position: 'absolute',
      right: -1,
      left: -1,
      bottom: 5,
      height: 2,
      backgroundColor: theme.palette.common.white,
      zIndex: -1,
    },
  },
});

const ProductClaimModifiersFieldArray = ({ fields, label, onFieldFocus, onFieldBlur, disabled, classes }) => (
  <FormControl
    className={classes.root}
    component="div"
  >
    {label.length > 0 &&
      <FormLabel
        className={classes.labelOverlap}
        component="legend"
      >
        {label}
      </FormLabel>
    }
    <div className={classes.fields}>
      {['', '', '', ''].map((field, index) => (
        <Field
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          id={`${fields.name}[${index}]`}
          name={`${fields.name}[${index}]`}
          component={TextField}
          className={classNames(classes.textField, {
            [classes.textFieldNotFirst]: index !== 0,
          })}
          inputRootClassName={classNames({
            [classes.inputRootNotFirst]: index !== 0,
            [classes.inputRootNotLast]: index !== 3,
          })}
          validate={[validate.minLength2]}
          normalize={normalize.modifiers}
          maxLength="2"
          fullWidth
          onFocus={event => onFieldFocus({
            [`Modifiers[${index}]`]: event.target.value,
          })}
          onBlur={(event) => {
            if (event.target.value) {
              onFieldBlur({
                [`Modifiers[${index}]`]: event.target.value,
              });
            }
          }}
          disabled={disabled}
        />
      ))}
    </div>
  </FormControl>
);

ProductClaimModifiersFieldArray.propTypes = {
  fields: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
  label: PropTypes.string,
  onFieldFocus: PropTypes.func.isRequired,
  onFieldBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    textField: PropTypes.string.isRequired,
    labelOverlap: PropTypes.string.isRequired,
  }).isRequired,
};

ProductClaimModifiersFieldArray.defaultProps = {
  label: '',
  disabled: false,
};

export default withStyles(styles)(ProductClaimModifiersFieldArray);



// WEBPACK FOOTER //
// ./src/components/workflow/ProductClaim/ProductClaimModifiersFieldArray.js